import { Button, InfiniteScroll, printComponent, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import MedicalRecordPresenter from "./MedicalRecordPresenter";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import DateRangePicker from "../../../components/common/DateRangePicker";
import React from "react";
import PrintMedicalRec from "../PrintMDS/PrintMedicalRec";
import { DialogConfirmation } from "../../../components/common/Converter";
import { renderToStaticMarkup } from "react-dom/server";
import InputFactory from "../../../components/InputFactory";

class MedicalRecordPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new MedicalRecordPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      isModalOpen: false,
      objects: [],
      object: {},
      count: 0,
      limit: 10,
      current: 1,
    };
    this.contractPDF = React.createRef();
  }

  getCollectionName() {
    return "medical_record";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleMedicalRec() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
  }
  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  // delete function
  async handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handlePrintAction(object) {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;

    const printContentElement = PrintMedicalRec({ object });
    const printContentHTML = renderToStaticMarkup(printContentElement);

    const cssStyles = `
        body {
            font-family: Arial, sans-serif;
            padding: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
            table {
            width: 100%;
            border-collapse: collapse;
        }
        .page-break {
            page-break-before: always;
        }
        @page {
            margin: 0;
        }
    `;

    iframeDoc.open();
    iframeDoc.write(`
        <html>
          <head>
            <title>Print PDS</title>
            <style>${cssStyles}</style>
          </head>
          <body>
            ${printContentHTML}
            <script>
                window.onload = function() {
                    window.print();
                    window.onafterprint = function() {
                        window.close();
                    };
                };
            </script>
          </body>
        </html>
    `);
    iframeDoc.close();
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const fields = Object.keys(schema.fields)
      .filter(
        (item) =>
          ![
            "id",
            "medicalCertificate",
            "sickLeave",
            "acl",
            "medication",
          ].includes(item)
      )
      .join(",");
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="d-none">
          <div ref={this.contractPDF} id="contractPDF">
            <PrintMedicalRec object={this.state.object} />
          </div>
        </div>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} MDS {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex gap-3">
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, ...options } = schema.filters[field];
                    return (
                      <InputFactory
                        key={field}
                        className="ms-1"
                        type={type}
                        field={field}
                        where={{}}
                        onChange={this.onChangeFilter.bind(this, type)}
                        {...options}
                      />
                    );
                  })}
                  <DateRangePicker
                    fields={["createdAt", "updatedAt", ""]}
                    onFilter={(filterObj) => {
                      try {
                        const update = new Date(filterObj.updatedAt.$lte);
                        update.setDate(update.getDate() + 1);
                        const formattedDate = update
                          .toISOString()
                          .split("T")[0];
                        console.log("UDPATE: ", formattedDate);
                        const filterStartDate = {
                          createdAt: {
                            $lte: formattedDate,
                            $gte: filterObj.createdAt.$gte,
                          },
                        };
                        this.searchSubmit(filterStartDate);
                        this.setState({ filters: filterStartDate });
                      } catch (e) {
                        this.searchSubmit({});
                        this.setState({ filters: {} });
                      }
                    }}
                  />
                  <Search
                    schemas={this.getSchemas()}
                    onSubmit={this.searchSubmit.bind(this)}
                    fields={schema.fields}
                  />
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="gap-3 d-flex"
                      style={{ marginLeft: "auto" }}
                    >
                      <Button onClick={this.handleMedicalRec.bind(this)}>
                        <i className="bi bi-plus-lg" /> Add New {schema.label}
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateCSV(fields)}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // indexCount={objects}
                // objectData={this.handleViewData.bind(this)}
                generateLeaveCard={this.handlePrintAction.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                viewObject={this.handleViewData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"></i>,
                    actionType: "MDS",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "immunizationHistory",
                    "medication",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {/* {this.state.isModalOpen && (
          <SuspensionForm
            refetchData={this.refetchData.bind(this)}
            closeCollection={this.closeModal.bind(this)}
            object={this.state.object}
          />
        )} */}
      </>
    );
  }
}

export default withRouter(MedicalRecordPage);
